import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { AuthComponent } from '../auth/auth.component';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private _dialog: MatDialog, private _location: Location, private _router: Router) {
  }

  private _dialogRef: MatDialogRef<AuthComponent, any>;

  openPopup() {
    if (this._dialogRef) {
      return;
    }

    let data = { baseUrl: '' };

    this._dialogRef = this._dialog.open(AuthComponent, {
      height: 'auto',
      width: '310px',
      data
    });

    this._dialogRef.afterOpened().subscribe(
      (result: any) => {
        this._location.replaceState('/auth');
      }
    );

    this._dialogRef.afterClosed().subscribe(
      (result: any) => {
        // this._location.replaceState(data.baseUrl);
        // this._router.navigateByUrl(data.baseUrl);
        this._dialogRef = null;
      }
    );
  }
}
